import { defineMessages } from "react-intl";

import ChecklistDescriptor from "@app/component/flows/types/ChecklistDescriptor";

import { emailTemplatesTourConfiguration } from "./emailTemplates";
import { sendingViaMapTourConfiguration } from "./sendingViaMapTour";
import { sendingViaRecordListTourConfiguration } from "./sendingViaRecordListTour";
import { sendingViaRecordPreviewTourConfiguration } from "./sendingViaRecordPreviewTour";

const messages = defineMessages({
  description: {
    id: "guides.sendingEmails.checklist.description",
    defaultMessage:
      "This guide will show you the basics you need to use Map My Customers like a pro, custom to each role.",
  },
  emailTemplates: {
    id: "guides.sendingEmails.checklist.emailTemplates",
    defaultMessage: "Creating & Using Email Templates",
  },
  sendingViaMap: {
    id: "guides.sendingEmails.checklist.sendingViaMap",
    defaultMessage: "Sending Emails via Map Lasso",
  },
  sendingViaRecordList: {
    id: "guides.sendingEmails.checklist.sendingViaRecordList",
    defaultMessage: "Sending Emails via List View",
  },
  sendingViaRecordPreview: {
    id: "guides.sendingEmails.checklist.sendingViaRecordPreview",
    defaultMessage: "Sending an Individual Email from a Record",
  },
  title: {
    id: "guides.sendingEmails.checklist",
    defaultMessage: "Getting started",
  },
});

export const sendingEmailsChecklistConfiguration: ChecklistDescriptor = {
  id: "mmc-sending-emails",
  steps: [
    {
      id: "mmc-sending-emails-via-map",
      path: "/map",
      title: messages.sendingViaMap,
      tour: sendingViaMapTourConfiguration,
    },
    {
      id: "mmc-sending-emails-via-record-list",
      path: "/company",
      title: messages.sendingViaRecordList,
      tour: sendingViaRecordListTourConfiguration,
    },
    {
      id: "mmc-sending-emails-via-record-preview",
      title: messages.sendingViaRecordPreview,
      tour: sendingViaRecordPreviewTourConfiguration,
    },
    {
      id: "mmc-sending-emails-templates",
      title: messages.emailTemplates,
      tour: emailTemplatesTourConfiguration,
    },
  ],
  subTitle: messages.description,
  title: messages.title,
};
